import React from 'react';
import { Link } from 'react-router-dom';

const RecentActivity = ({ activities }) => {
    return (
        <div className="dashboard-card" style={{ marginTop: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 'bold', color: '#1F1F1F' }}>Recent Activity</h3>
                <span style={{ fontSize: '12px', color: '#888' }}>Real-time</span>
            </div>

            <div className="activity-list">
                {activities && activities.length > 0 ? (
                    activities.map((act, index) => (
                        <div key={index} style={{
                            display: 'flex',
                            padding: '12px 0',
                            borderBottom: index !== activities.length - 1 ? '1px solid #f0f0f0' : 'none',
                            alignItems: 'flex-start',
                            gap: '12px'
                        }}>
                            {/* Icon Circle */}
                            <div style={{
                                width: '36px', height: '36px', borderRadius: '50%',
                                background: act.type === 'BILL' ? '#e8f5e9' : (act.type === 'ITEM' ? '#e3f2fd' : '#fff3e0'),
                                color: act.type === 'BILL' ? '#2e7d32' : (act.type === 'ITEM' ? '#1565c0' : '#ef6c00'),
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: '16px'
                            }}>
                                {act.type === 'BILL' ? '🧾' : (act.type === 'ITEM' ? '💍' : '👤')}
                            </div>

                            {/* Content */}
                            <div style={{ flex: 1 }}>
                                <div style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#1F1F1F',
                                    marginBottom: '4px'
                                }}>
                                    {act.desc}
                                </div>
                                <div style={{
                                    fontSize: '13px',
                                    color: '#666',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    {act.amount ? <span>₹{act.amount.toLocaleString()}</span> : null}
                                    {act.amount && <span style={{ color: '#ddd' }}>•</span>}
                                    <span style={{ color: '#999' }}>
                                        {new Date(act.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>No recent activity</div>
                )}
            </div>

            <Link to="/billing/history" style={{
                display: 'block',
                textAlign: 'center',
                fontSize: '13px',
                color: '#B8860B',
                textDecoration: 'none',
                fontWeight: '600',
                paddingTop: '12px',
                borderTop: '1px solid #f9f9f9',
                marginTop: '8px'
            }}>
                View All Activity →
            </Link>
        </div>
    );
};

export default RecentActivity;
